import React, {Component} from "react";
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { global } from './../../config.js';
import withRouter from './../withRouter';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';

import ClipLoader from "react-spinners/ClipLoader";

const urlTypes = [
    {
        name: "Артефакт",
        type: "artefact"
    },
    {
        name: "IZI Travel",
        type: "izitravel"
    }
]

class Urls extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.params.id,
            loading: true,
            error: false,
            show_modal_delete: false,
            show_modal_add: false,
            deleting: false,
            adding: false,
            urls: [],
            item: {},
            currentType: "",
            currentName: "",
            currentId: 0
        };

        this.item = this.item.bind(this)
        this.handleCloseAdd = this.handleCloseAdd.bind(this)
        this.handleCloseDelete = this.handleCloseDelete.bind(this)
        this.delete = this.delete.bind(this)
        this.handleChangeUrl = this.handleChangeUrl.bind(this)
        this.add = this.add.bind(this)
    }

    componentDidMount(){
        this.item()
    }

    item() {
        
        const requestOptions = {
            method: 'GET',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };

        fetch(global.endpoint_api + '/items/' + this.state.id, requestOptions)
        .then(res => res.json().then(
            (result) => {

                if (res.status === 200 && !result.error) {
                    this.setState({
                        item: result,
                        loading: false,
                        urls: result.urls
                    });
                } else {
                    if (result.error) {
                        this.setState({
                            error: result.error.message
                        });
                    } else {
                        this.setState({
                            error: "Произошла ошибка. Пожалуйста, попробуйте позже."
                        });
                    }
                }
                this.setState({
                    loading: false
                });


            }
        ))

    }

    add() {
       
        let url = document.getElementById("value_url").value

        if (url === '') {
            this.setState({
                error: "Не указана ссылка"
            })
            return;
        }

        this.setState({
            adding: true,
            error: false
        })

        const requestOptions = {
            method: 'PUT',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            },
            body: JSON.stringify({url, type: this.state.currentType})
        };

        fetch(global.endpoint_api + '/items/' + this.state.id + "/urls", requestOptions)
            .then(res => res.json().then(
            (result) => {
                if (res.status === 200 && !result.error) {
                    this.setState({
                        urls: result
                    });
                } else if (result.error) {
                    this.setState({
                        error: result.error.message
                    });
                } else {
                    this.setState({
                        error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                    });
                }
    
                this.setState({
                    adding: false,
                    show_modal_add: false
                });
            },
            (error) => {}
        ))
    }


    delete() {

        this.setState({
            deleting: true,
            error: false
        })

        const requestOptions = {
            method: 'DELETE',
            headers: { 
                'Authorization': 'Bearer ' + Cookies.get('session-acs'),
                'Content-Type': 'application/json',
                "Access-Control-Allow-Origin": "*"
            }
        };

        fetch(global.endpoint_api + '/items/' + this.state.id + "/urls/" + this.state.currentId, requestOptions)
            .then(res => res.json().then(
            (result) => {
                if (res.status === 200 && !result.error) {
                    this.setState({
                        urls: result
                    });
                } else if (result.error) {
                    this.setState({
                        error: result.error.message
                    });
                } else {
                    this.setState({
                        error: "Неизвестная ошибка. Пожалуйста, попробуйте позже."
                    });
                }

                this.setState({
                    deleting: false,
                    show_modal_delete: false
                });
            },
            (error) => {}
        ))
    }

    handleCloseAdd() {
        this.setState({
            show_modal_add: false
        })
    }

    handleCloseDelete() {
        this.setState({
            show_modal_delete: false
        })
    }

    handleChangeUrl(event) {
        console.log(event.target)
    }


    render() {

        let { item, urls, loading, show_modal_add, adding, show_modal_delete, deleting, error } = this.state
        let self = this

        return (
            <>
            <Row className="mb-4">
                <Col>
                    <Link to={"/items/" + this.state.id}>&larr; Назад</Link>
                </Col>
            </Row>
            <Row>
                <Col md={9} lg={6}>
                    <ClipLoader
                        loading={loading}
                        size={30}
                    />

                    {!item.title && !loading && (
                        <h4>Объект не найден или был удален</h4>
                    )}

                    {item.title && !loading && (
                        <>
                            <div className="mb-5">

                                <div className="card card-simple">
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <h5 className="mb-4"><Image src="/images/icons/link.svg" width={20}/> Ссылки</h5>

                                            
                                            {Object.keys(urlTypes).map(function(key) {
                                                return (
                                                    <div key={key}>
                                                        <div className="mt-3 mb-4">
                                                            <Row className="d-flex justify-content-between">
                                                                <Col xs={7}>
                                                                    <p className="text-bold">{urlTypes[key].name}</p>
                                                                </Col>
                                                                <Col xs={5}>
                                                                    {urls.findIndex(x => x.type === urlTypes[key].type) !== -1 && (
                                                                        <p className="pointer small text-danger float-end" to="#" onClick={() => self.setState({show_modal_delete: true, currentType: urlTypes[key].name, currentId: urls.find(x => x.type === urlTypes[key].type).id})}>&#x2715; Удалить</p>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                            
                                                            <div>{urls.findIndex(x => x.type === urlTypes[key].type) !== -1
                                                                ? <p className="small truncate-text mb-1"><Link to={urls.find(x => x.type === urlTypes[key].type).url} target="_blank">{urls.find(x => x.type === urlTypes[key].type).url}</Link></p>
                                                                : <Button variant="dark" size="sm" className="" onClick={() => self.setState({show_modal_add: true, currentName: urlTypes[key].name, currentType: urlTypes[key].type})}>Добавить</Button>}
                                                            </div>
                                                            
                                                        </div>

                                                        {urlTypes.length - 1 > key && (
                                                            <hr />
                                                        )}
                                                        
                                                    </div>
                                                )
                                            })}
                                        </div>

                                    
                                    </div>
                                </div>

                            </div>

                            <Modal show={show_modal_add} onHide={this.handleCloseAdd} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Добавить</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Укажите внешнюю ссылку для «{this.state.currentName}»:</p>
                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Control type="text" placeholder="https://example.ru/" id="value_url" />
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer className="justify-content-between">
                                    <Button variant="light" disabled={adding} onClick={this.handleCloseAdd}>
                                        Отмена
                                    </Button>
                                    <Button variant="dark" disabled={adding} onClick={this.add}>
                                        Добавить
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={show_modal_delete} onHide={this.handleCloseDelete} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Удалить</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>Вы действительно хотите удалить внешнюю ссылку для «{this.state.currentType}»?</p>
                                </Modal.Body>
                                <Modal.Footer className="justify-content-between">
                                    <Button variant="light" disabled={deleting} onClick={this.handleCloseDelete}>
                                        Нет
                                    </Button>
                                    <Button variant="danger" disabled={deleting} onClick={this.delete}>
                                        Да
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            
                        </>
                    )}

                    {error && (
                        <p className="text-danger">{error}</p>
                    )}
                    
                </Col>
            </Row>
            </>
        )

    }
}

export default withRouter(Urls);